// Template291: Bali - Día continuación sin hero (Page8-style)
// Cabecera, imagen banner arriba, bloques, caja verde, bloque lista (consejos), sticker + tip abajo.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template291 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const bannerImage = getImageSrc("banner");
	const logoImage = getCanvasImageUrl("logo");
	const blocks = Array.isArray(page?.data?.blocks) ? page.data.blocks : [];
	const footerBox = page?.data?.footerBox;
	const listBlock = page?.data?.listBlock;
	const footerStickerId = page?.data?.footerStickerId;
	const footerTip = page?.data?.footerTip;
	const footerSticker = footerStickerId ? getImageSrc(footerStickerId) : null;
	const actualHeaderColor = headerBackgroundColor || "#2F6B4F";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
		marginBottom: 0.5,
		marginTop: 1,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{bannerImage && (
				<Box
					data-block-id="image-0"
					component="img"
					src={bannerImage}
					alt=""
					sx={{ width: "100%", height: 150, objectFit: "cover" }}
				/>
			)}

			<Box data-block-id="text-1" sx={{ padding: "10px 12px", flex: 1, position: "relative" }}>
				<Box data-block-id="text-2" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
					{blocks.map((block, idx) => {
						const blockImage = block.imageId
							? getImageSrc(block.imageId)
							: null;
						const sabiasQueList = Array.isArray(block.sabiasQue)
							? block.sabiasQue
							: [];
						return (
							<Box
								key={idx}
								data-block-id={`text-${idx + 3}`}
								sx={{
									display: "flex",
									gap: 2.5,
									alignItems: "flex-start",
									position: "relative",
								}}
							>
								{blockImage && (
									<Box
										component="img"
										src={blockImage}
										alt=""
										sx={{
											width: "40%",
											height: 110,
											borderRadius: "12px",
											objectFit: "cover",
											flexShrink: 0,
										}}
									/>
								)}
								{sabiasQueList.length > 0 &&
									sabiasQueList.map((sq, i) => (
										<Box
											key={i}
											sx={{
												position: "absolute",
												top: i * 40,
												left: "34%",
												zIndex: 2,
											}}
										>
											<SabiasQue
												icono={sq.icono || "💬"}
												texto={sq.texto || ""}
											/>
										</Box>
									))}
								<Box
									sx={{
										width: blockImage ? "60%" : "100%",
										position: "relative",
									}}
								>
									{block.titulo && (
										<Box component="h3" sx={estiloH3}>
											{block.titulo}
										</Box>
									)}
									{block.contenido && (
										<Box component="p" sx={estiloP}>
											{block.contenido}
										</Box>
									)}
								</Box>
							</Box>
						);
					})}
				</Box>

				{footerBox?.content && (
					<Box
						data-block-id="text-4"
						sx={{
							backgroundColor: "#c8e6d4",
							border: "2px solid #2F6B4F",
							borderRadius: "12px",
							padding: "8px 14px",
							fontSize: 12,
							color: "#444",
							textAlign: "center",
							marginTop: 1.5,
						}}
					>
						{footerBox.content}
					</Box>
				)}

				{listBlock &&
					listBlock.titulo &&
					Array.isArray(listBlock.items) &&
					listBlock.items.length > 0 && (
						<Box
							data-block-id="text-5"
							sx={{
								backgroundColor: "#c8e6d4",
								borderRadius: "12px",
								padding: "12px 14px",
								marginTop: 1.5,
							}}
						>
							<Box component="h3" sx={{ ...estiloH3, marginBottom: 1 }}>
								{listBlock.titulo}
							</Box>
							<Box
								component="ul"
								sx={{
									margin: 0,
									paddingLeft: 2.25,
									fontSize: 13,
									color: "#444",
									display: "flex",
									flexDirection: "column",
									gap: 0.75,
								}}
							>
								{listBlock.items.map((item, i) => (
									<Box component="li" key={i}>
										{item}
									</Box>
								))}
							</Box>
						</Box>
					)}

				{footerSticker && (
					<Box
						component="img"
						src={footerSticker}
						alt=""
						sx={{
							width: 90,
							position: "absolute",
							bottom: isSmallScreen ? -80 : 0,
							left: -30,
						}}
					/>
				)}
				{footerTip && (
					<Box
						sx={{
							position: "absolute",
							bottom: isSmallScreen ? -40 : 30,
							left: 50,
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "12px 12px 12px 0",
							padding: "10px 12px",
							fontSize: 11,
							color: "#444",
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							maxWidth: 300,
						}}
					>
						{footerTip}
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template291.thumbnail = "/images/template-1.png";
export default Template291;
